import { render, staticRenderFns } from "./provideOrganization.vue?vue&type=template&id=333b27ee&scoped=true&"
import script from "./provideOrganization.vue?vue&type=script&lang=js&"
export * from "./provideOrganization.vue?vue&type=script&lang=js&"
import style0 from "./provideOrganization.vue?vue&type=style&index=0&id=333b27ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b27ee",
  null
  
)

export default component.exports